import { DEFAULT_TIMEZONE } from '@tcrd/shared';
import { getLang } from '../i18n/translator';

/** Fechas y horas en el idioma elegido. */
export const loc = getLang() === 'en' ? 'en-US' : 'es-DO';

const tz = DEFAULT_TIMEZONE;

export function fmtDateTime(d: string | Date | null | undefined): string {
  if (!d) return '—';
  return new Date(d).toLocaleString(loc, { timeZone: tz, weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
}

export function fmtDate(d: string | Date | null | undefined): string {
  if (!d) return '—';
  return new Date(d).toLocaleDateString(loc, { timeZone: tz, weekday: 'long', day: 'numeric', month: 'long' });
}

export function fmtTime(d: string | Date | null | undefined): string {
  if (!d) return '—';
  return new Date(d).toLocaleTimeString(loc, { timeZone: tz, hour: 'numeric', minute: '2-digit' });
}

export function fmtKm(meters: number | null | undefined): string {
  if (meters == null) return '—';
  return meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(meters < 10_000 ? 1 : 0)} km`;
}

export function fmtDuration(seconds: number | null | undefined): string {
  if (seconds == null) return '—';
  const m = Math.max(1, Math.round(seconds / 60));
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${m % 60 ? `${m % 60} min` : ''}`.trim();
}

/** Valor para <input type="datetime-local"> en la zona del negocio. */
export function toLocalInput(d: Date): string {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(d);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '00';
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
}

/** Convierte "YYYY-MM-DDTHH:mm" (hora de Santo Domingo, UTC-4 sin horario de verano) a ISO UTC. */
export function fromLocalInput(v: string): string {
  return new Date(`${v}:00-04:00`).toISOString();
}

export function relativeMinutes(d: string | Date): string {
  const diff = Math.round((new Date(d).getTime() - Date.now()) / 60_000);
  if (diff <= 0) return 'vencida';
  if (diff < 60) return `${diff} min`;
  return `${Math.floor(diff / 60)} h ${diff % 60} min`;
}
